<template>
    <layout>
        <template v-slot:header>
            <AppHead title="Create Sale" />
            <h2>Create Sale</h2>
            <BreadCrumbs activeItem="Create Sale" :crumbs="{ home: 'Dashboard' }" />
            <flash-messages />
        </template>

        <template v-slot:default>
            <div class="col-12 col-xl-8 px-0">
                <card headerStyle="dark" title="New Sale">
                    <form @submit.prevent="store">
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <jet-label for="title" value="Title" />
                                <jet-input id="title" type="text" class="form-control" v-model="form.title" />
                                <jet-input-error :message="form.errors.title" class="mt-2" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-3">
                                <jet-label for="start_at" value="Start" />
                                <Calendar v-model="form.start_at" class="w-100" id="start_at" :showIcon="true"
                                    :selectOtherMonths="true" />
                                <jet-input-error :message="form.errors.start_at" class="mt-2" />

                                <div class="form-check">
                                    <input type="checkbox" id="start_at_has_time" class="form-check-input"
                                        v-model="form.start_at_has_time" />
                                    <jet-label for="start_at_has_time" value="Time" />
                                </div>
                            </div>
                            <div class="form-group col-sm-3" v-if="form.start_at_has_time">
                                <jet-label for="start_at_time" value="Time" />
                                <InputMask mask="99:99" slotChar="hh:mm" placeholder="hh:mm" class="form-control"
                                    type="text" v-model="form.start_at_time" />
                                <SelectButton v-model="form.start_at_ampm" :options="['am', 'pm']" />
                            </div>

                            <div class="form-group col-sm-3">
                                <jet-label for="end_at" value="End" />
                                <Calendar v-model="form.end_at" class="w-100" id="end_at" :showIcon="true"
                                    :selectOtherMonths="true" />
                                <jet-input-error :message="form.errors.end_at" class="mt-2" />

                                <div class="form-check">
                                    <input type="checkbox" id="end_at_has_time" class="form-check-input"
                                        v-model="form.end_at_has_time" />
                                    <jet-label for="end_at_has_time" value="Time" />
                                </div>
                            </div>
                            <div class="form-group col-sm-3" v-if="form.end_at_has_time">
                                <jet-label for="end_at_time" value="Time" />
                                <InputMask mask="99:99" slotChar="hh:mm" placeholder="hh:mm" class="form-control"
                                    type="text" v-model="form.end_at_time" />
                                <SelectButton v-model="form.end_at_ampm" :options="['am', 'pm']" />
                            </div>
                        </div>

                        <div class="bottom-button">
                            <jet-button class="px-5" btnStyle="success" icon="fas fa-plus" :disable="form.processing"
                                type="submit">Create Sale</jet-button>
                        </div>
                    </form>
                </card>
            </div>
        </template>
    </layout>
</template>

<script>
import Layout from '@/Shared/Admin/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'

import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetActionMessage from '@/Jetstream/ActionMessage'
import FlashMessages from '@/Shared/FlashMessages'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import Calendar from 'primevue/calendar';
import InputMask from 'primevue/inputmask'
import SelectButton from 'primevue/selectbutton'
import Multiselect from '@vueform/multiselect'

export default {
    components: {
        FileInput,
        SelectInput,
        TextInput,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetCheckbox,
        JetInputError,
        JetLabel,
        FlashMessages,
        Layout,
        BreadCrumbs,
        Calendar,
        InputMask,
        SelectButton,
        Multiselect
    },
    remember: 'form',
    props: {
    },
    data() {
        return {
            form: this.$inertia.form({
                title: null,
                start_at: null,
                start_at_has_time: false,
                start_at_time: null,
                start_at_ampm: 'am',
                end_at: null,
                end_at_has_time: false,
                end_at_time: null,
                end_at_ampm: 'am',
            }),
        }
    },
    methods: {
        store() {
            this.setDates()
            this.form.post(this.route('admin.sales.store'))
        },
        setDates() {
            if (this.form.start_at && this.form.start_at_has_time) {
                let startString = moment(this.form.start_at).format('YYYY-MM-DD') + ' ' +
                    this.form.start_at_time + ' ' + this.form.start_at_ampm
                this.form.start_at = moment(startString, 'YYYY-MM-DD hh:mm a')
            }
            if (this.form.end_at && this.form.end_at_has_time) {
                let endString = moment(this.form.end_at).format('YYYY-MM-DD') + ' ' +
                    this.form.end_at_time + ' ' + this.form.end_at_ampm
                this.form.end_at = moment(endString, 'YYYY-MM-DD hh:mm a')
            }
        },
    },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>